export default {
  listAddressType: [],
  addressType: {
    ativo: true,
    id: 0,
    nome: '',
  },
}
